import React, { Component } from 'react';
import PanelHolder from '../../model/PanelHolder.js';
import { listenTo, clearBindings } from '../../util/Utility.js';
import moment from 'moment';

export default class AnnouncementView extends Component {

  fetchObjects(limit, callback) {
    console.log("Ministry ID: " + this.props.ministry.key);
    listenTo("announcements", this, callback, {
      orderByChild: 'ministryID',
      equalTo: this.props.ministry.key,
      limitToLast: limit
    }, item => item.expires > moment().startOf('day').unix())
  }

  componentWillUnmount() {
    clearBindings();
  }

  render() {
    return (
      <PanelHolder addable type="announcement" fetch={this.props.ministry.key} fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/announcements/AnnouncementView.js
 **/